module.exports = __webpack_public_path__ + "img/connect-2.7dec4b2d.svg";